export const getHeroSectionContent = ({ i18n }) => {
  const content = {
    title: i18n.gettext('Cuotas sin Tarjeta de Mercado Pago'),
    subtitle: i18n.gettext('Compra en tu tienda favorita y paga en cuotas sin tarjeta'),
    buttonText: i18n.gettext('Conoce las tiendas'),
    backgroundImages: {
      mobile: {
        original: 'buyers/hero/_background-hero-mobile-version-3.jpeg',
        image: 'buyers/hero/MP-mobile.png',
      },
      desktop: {
        original: 'buyers/hero/_background-hero-desktop-version-3.jpeg',
        image: 'buyers/hero/MP-desktop.png',
      },
      tablet: {
        original: 'buyers/hero/_background-hero-desktop-v3.jpeg',
        image: 'buyers/hero/MP-desktop.png',
      },
    },
  };

  return content;
};
